module.exports = __webpack_public_path__ + "static/media/tyro-lac-opti.ba2708d9.mp4";